window.displayScreenTimeouts = [];

function displayScreen2()
{
	var isWords = listStimType[trialRow] == 2;

	window.currentScreenIndex = 0;
	var screensCount = listTrialScreensTimings[trialRow].length;
	//recursively show screens
	delayedScreensView();
	window.isLoopTrial = (columnForTrial('stimOptions', trialRow).indexOf('loop') >= 0) && (listStimType[trialRow]==1)
	window.loopedOnce = 0;
	window.responsesBeforeLoop = responses.length;
	var lastISI = calculateLastISI(listTrialScreensTimings[trialRow]);
	var lastPresTime = calculateLastPresTime(listTrialScreensTimings[trialRow]);

	displayText("topLeft", replaceVariables(listArrays[allColumns.indexOf('topLeft')][trialRow], undefined, undefined, undefined, 1));
	displayText("topRight", replaceVariables(listArrays[allColumns.indexOf('topRight')][trialRow], undefined, undefined, undefined, 1));

	timeInMs = performance.now();

	function delayedScreensView() {
		window.setupScreenStart = performance.now();
		console.info('**************** TRIAL ' + trialRow + ' - SCREEN ' + (currentScreenIndex + 1)  + ' ***************');

		if(!window.loopedOnce){
			hideTrialText(trialRow); // only hides if !allTrial !allStim
		}
		hideMask();

		var currentScreenTimings = listTrialScreensTimings[trialRow][currentScreenIndex];

		//reached undefined screen
		if(currentScreenTimings === undefined) {
			return;
		}

		if (isWords) {
			minImagesTop = showWordTest(currentScreenTimings.startStimuliIndex, currentScreenTimings.startStimuliIndex + currentScreenTimings.stimuliNumber - 1);
		} else {
			minImagesTop = showImageTest(currentScreenTimings.startStimuliIndex, currentScreenTimings.startStimuliIndex + currentScreenTimings.stimuliNumber - 1);
		}
		//show text after images so we could have position of the images as text is relative to images
		//trialText withStim
		showTrialTextForScreen(trialRow, currentScreenIndex);

		hideFixationForScreen(trialRow);
		showTrialFixationForScreen(trialRow);


		//show trial text if any
		//reshow on each screen in order to adjust the position for current screen image sizes
		showTrialTextAllStim(trialRow, window.minTrialAllImagesTop || window.minImagesTop);
		showTrialTextAllTrial(trialRow, window.minTrialAllImagesTop || window.minImagesTop);//all trial has higher priority over allStim

		//show allStim and allTrial on first screen after images are positioned
		if (currentScreenIndex == 0) {
			showTrialFixationAllStimOrTrial(trialRow);
		}

		currentScreenIndex++;
		console.log("show this screen for ", currentScreenTimings.presTime, 'ms and delay te next one for ', currentScreenTimings.isi, 'ms');

		//responseWindow
		enableResponseWindowWithStim(trialRow);

		window.isiStart = performance.now();

		if ( currentScreenIndex < screensCount ) {
			//hide screen after presTime if presTime != 0
			currentScreenTimings.presTime && (window.lastPresPostponeIndex = startDisplayScreenTimeout( function(info) {
				window.recordPresTime(info);
				// currentScreenIndex && recordRealScreenDisplayTime(window.trialRow, window.screenViewStart);
				currentScreenIndex && console.info('!!! PERFORMANCE screen was visible for ', performance.now() - window.screenViewStart);
				hideTargetAndTest();
				if(!window.loopedOnce || !window.isLoopTrial){
					disableResponseWindowWithStim(trialRow);
					hideTrialText(trialRow);
					hideFixationForISI(trialRow);
				}

				verticalShift = 0;
				window.isiStart = performance.now();

				//show mask if any
				if (listArrays[allColumns.indexOf('mask')][trialRow]!="na") {
					displayMask();
				}

				//show ISI text after mask (if any) position is computed
				showTrialTextISIForScreen(trialRow, currentScreenIndex - 1);

				//show ISI fixation
				showTrialFixationISIForScreen(trialRow);

				//display next screen
				//show next screen after isi
				startDisplayScreenTimeout( function(info){
					window.recordISI(info);
					delayedScreensView();
				}, currentScreenTimings.isi, window.lastTs);

			}, currentScreenTimings.presTime, window.lastTs));


		} else {
			//last screen
			if(!window.loopedOnce){
				enableResponseWindowLastStim(trialRow);
			}

			if(window.isLoopTrial){
				currentScreenIndex = 0;
				postpone(function(){
					if(responses.length == window.responsesBeforeLoop){
						hideImages();
						postpone(function(){
							if(responses.length == window.responsesBeforeLoop){
								window.loopedOnce = 1;
								delayedScreensView();
							}
						}, lastISI);
					}
				}, lastPresTime);
			}

			//this is last screen, hide it after presTime if presTime != 0
			var lastScreenPresTime = currentScreenTimings.presTime;
			//hack to avoid race between presTime and responseTime when equal, in principle trial shouldn't be affected presentation wise
			if(lastScreenPresTime == listTrialResponseWindow[trialRow].timeout && listTrialResponseWindow[trialRow].startPosition == 'lastStim'){
				lastScreenPresTime += window.frameRate;
			}

			currentScreenTimings.presTime && (window.lastPresPostponeIndex = startDisplayScreenTimeout( function(info) {
				window.recordPresTime(info);
				// currentScreenIndex && recordRealScreenDisplayTime(window.trialRow, window.screenViewStart);
				console.info('!!! PERFORMANCE screen was visible for ', performance.now() - window.screenViewStart);
				hideTargetAndTest();

				//hide text if no allTrial defined
				hideTextAfterLastStim(trialRow);
				//show afterStim if any
				showTrialTextAfterStim(trialRow);

				hideFixationAfterLastStim(trialRow);

				//responseWindow
				disableResponseWindowLastStim(trialRow);

				if (columnForTrial('type', trialRow) == 'learn') {
					autoAdvance();
				} else {
					// multiple key responses
					var trialOptions = window.listTrialResponseOptions[window.trialRow] || {};
					var shouldRecordMultipleKeys = Boolean(trialOptions.multipleResponses);
					// if we have multiple keys to record and we recorded the maximum required, then we can move to the next trial
					if (shouldRecordMultipleKeys && window.trialKeysPressedCounter >= trialOptions.multipleResponses.max) {
						nextTrialWithKeys(window.keysTrial);
						return;
					}
					// presentation time finished, but did not reach minimum yet, will end once minimum is reached
					if(shouldRecordMultipleKeys){
						trialOptions.multipleResponses.presentationFinished = true;
					}
					enableResponseWindowAfterStim(trialRow);
				}

			}, lastScreenPresTime, window.lastTs));
		}
	}
}

//function used for display screen timeouts (such as ISI, presTime)
// callback - is the function called after the timeout
// timeout  - the amount of time after which the callback is executed
// startTime - optional timestamp used as the start point of the timeout
function startDisplayScreenTimeout(callback, timeout, startTime) {
	var to = window.postpone(callback, timeout, startTime);

	if (timeout > 0) {

		if (!window.displayScreenTimeouts) {
			window.displayScreenTimeouts = [];
		}
		window.displayScreenTimeouts.push(to);
	}

	return to;
}


function clearDisplayScreenTimeouts() {
	var to;
	if (window.displayScreenTimeouts) {
		while (to = window.displayScreenTimeouts.shift()) {
			window.clearPostpone(to);
		}
	}
}

function recordRealScreenDisplayTime(trialRow, start_time) {
	var actual_time = performance.now() - start_time;
	window.presTime_actual_temp.push(actual_time | 0); //save as int
}

function calculateLastISI(timings){
	var lastPositiveISI = 0;
	for(var i = 0; i < timings.length; i++){
		if(timings[i].isi > 0){
			lastPositiveISI = timings[i].isi;
		}
	}
	return lastPositiveISI;
}

function calculateLastPresTime(timings){
	var lastPositivePresTime = 0;
	for(var i = 0; i < timings.length; i++){
		if(timings[i].presTime > 0){
			lastPositivePresTime = timings[i].presTime;
		}
	}
	return lastPositivePresTime;
}